import { render, staticRenderFns } from "./Vara.vue?vue&type=template&id=36ccbfd8&"
import script from "./Vara.vue?vue&type=script&lang=js&"
export * from "./Vara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports